export const SNAPASK_AUTH_TYPE = 'normal';
export const FACEBOOK_AUTH_TYPE = 'facebook';
export const PHONE_AUTH_TYPE = 'PHONE_AUTH_TYPE';
export const NOWTV_AUTH_TYPE = 'now_tv';
export const KAKAO_AUTH_TYPE = 'kakao';



// WEBPACK FOOTER //
// ./app/constants/authType.js